import _FormControl from "@material-ui/core/esm/FormControl";
import _Select from "@material-ui/core/esm/Select";
import _MenuItem from "@material-ui/core/esm/MenuItem";
import _InputLabel from "@material-ui/core/esm/InputLabel";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classnames from 'classnames';
import classes from './select-field.scss';
export const Select = _ref => {
  let {
      options,
      value = '',
      onChange,
      dataDropdown = '',
      wrapperClassName = '',
      floatingLabelText,
      hintText
    } = _ref,
    rest = _objectWithoutProperties(_ref, ["options", "value", "onChange", "dataDropdown", "wrapperClassName", "floatingLabelText", "hintText"]);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.selectWrapper, wrapperClassName),
    "data-dropdown": dataDropdown
  }, /*#__PURE__*/React.createElement(_FormControl, null, floatingLabelText && /*#__PURE__*/React.createElement(_InputLabel, {
    shrink: true,
    className: classes.label
  }, floatingLabelText), /*#__PURE__*/React.createElement(_Select, _extends({
    value: value,
    onChange: onChange,
    MenuProps: {
      PopoverClasses: {
        root: classes.menu
      },
      classes: {
        paper: classes.menuPaper
      }
    },
    classes: {
      icon: classes.icon
    },
    displayEmpty: true
  }, rest), /*#__PURE__*/React.createElement(_MenuItem, {
    value: "",
    disabled: true
  }, hintText), options.map(({
    value: optionValue,
    label,
    key,
    isHidden
  }) => /*#__PURE__*/React.createElement(_MenuItem, {
    className: classnames(classes.menuItem, {
      [classes.hidden]: isHidden,
      [classes.selectedItem]: value === optionValue
    }),
    key: key || optionValue,
    value: optionValue
  }, label)))));
};
export const SELECT_MENU_MAXHEIGHT = 300;